export const MODEL_ROUTE = '/payments';

export const HOSTED_PAYMENTS_URL = 'https://transaction.hostedpayments.com';
